<template>
    <div>
        <panel title="附件列表">
            <el-upload
                :action="actionUri"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-change="handleChange"
                :on-success="handleSuccess"
                :on-error="handleError"
                :data="{responseType: 'json'}"
                :multiple="false"
                :limit="99"
                :on-exceed="handleExceed"
                :file-list.sync="fileList"
                :show-file-list="false"
            >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                    （您提交的文件大小建议在2M以内，支持格式：{{ allowFileExt.join('、') }}）
                </div>
            </el-upload>
            <files-data-table
                :files.sync="uploadedFileList"
                :additional-columns = "additionalColumns"
                :editable="true"
            />
        </panel>
    </div>
</template>

<script>
import Constant from '../utils/constant'
import moment from 'moment'

export default {
    name: "FilesUploadComponent",
    data() {
        return {
            actionUri: Constant.SERVER_BASE_URL + '/ufile/scf.upload',
        }
    },
    props: {
        columns: {
            type: Array,
            default: () => {
                return [
                    {
                        type: 'index',
                    },
                    {
                        name: '附件名称',
                        field: 'name'
                    },
                    {
                        name: '附件大小',
                        field: 'size',
                        formatter: function (r, c, v) {
                            return (Number(v) || 0 / 1024).toFixed(2) + ' KB'
                        }
                    },
                    {
                        name: '上传时间',
                        field: 'createdDate',
                        formatter: function (r, c, v) {
                            return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                        }
                    },
                    {
                        name: '操作',
                        opts: [
                            {
                                label: '下载附件',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    try {
                                        let fileUri = Constant.SERVER_BASE_URL + '/files/' + row.fileId + '/!/' + row.name
                                        window.open(fileUri)
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                label: '删除附件',
                                class: 'el-icon-remove',
                                clickHandler: 'removeItem'
                            }
                        ]
                    }
                ]
            }
        },
        fileList: {
            type: Array,
            default: () => {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        allowFileExt: {
            type: Array,
            default: () => {
                return ['PDF', 'Word', 'Excel', 'JPG', 'PNG', 'BMP', 'GIF', 'RAR', 'ZIP']
            }
        },
        additionalColumns: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    computed: {
        fileTableData: {
            get() {
                return {
                    data: this.uploadedFileList,
                    count: this.uploadedFileList.length
                }
            }
        },
        uploadedFileList: {
            get() {
                return this.fileList.map(file => {
                    Object.keys(file).map(item => {
                        file[item.replace('f__', '')] = file[item]
                    })
                    return file
                }).filter(item => item.fileId)
            },
            set(newVal) {
                this.$emit('update:fileList', newVal)
            }
        }
    },
    mounted() {
    },
    methods: {
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        handleError(res, file, fileList) {
            this.$message({
                message: '文件上传失败！',
                type: 'error'
            })
        },
        handleSuccess: function (res, file, fileList) {
            try {
                if (res.status === 'success') {
                    this.$message({
                        message: '文件上传成功！',
                        type: 'success'
                    })
                    this.uploadedFileList = this.uploadedFileList.slice(0, this.max - 1).concat(res.files)
                    console.log(this.uploadedFileList)
                }
            } catch (e) {

            }
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleChange: function (file, fileList) {
            console.log(fileList)
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FilesUpload.vue